module.exports = __webpack_public_path__ + "static/media/about-img.f7bc3377.jpg";